export default function CourseSkills({ course }) {
  const skills = course?.skills;

  return (
    <section className="bg-[#FDF7FC] py-20 sm:py-24 lg:py-28">
      <div className="container relative z-[1] mx-auto">

        {/* ================= HEADER ================= */}

        <div className="grid gap-10 lg:grid-cols-[1.15fr_.85fr] lg:items-end">
          <div>
            <div className="flex items-center gap-3 text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
              <span className="h-px w-10 bg-current" />
              Skills & Capabilities
            </div>

            <h2 className="mt-6 max-w-[850px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(42px,4.8vw,68px)] font-normal leading-[1.04] tracking-[-0.04em] text-[#071A2F]">
              Skills you&apos;ll develop
              <br className="hidden sm:block" /> after{" "}
              <em className="font-normal text-[#8B1E3F]">
                {course?.shortTitle ||
                  course?.title ||
                  "this programme"}
              </em>
            </h2>
          </div>

          <p className="max-w-[520px] text-base leading-8 text-[#626873] lg:justify-self-end">
            Develop practical, analytical and professional capabilities that
            complement your academic knowledge and prepare you for evolving
            career environments.
          </p>
        </div>

        {/* ================= MAIN LAYOUT ================= */}

        <div className="mt-14 grid overflow-hidden border border-[#071A2F]/10 bg-white lg:grid-cols-[360px_1fr]">

          {/* LEFT FEATURE PANEL */}

          <div className="relative flex min-h-[520px] flex-col justify-between overflow-hidden bg-[#8B1E3F] p-8 text-white sm:p-10 lg:p-11">

            {/* decorative number */}

            <span
              aria-hidden="true"
              className="absolute -right-4 -top-8 font-['Libre_Caslon_Display',Georgia,serif] text-[180px] leading-none text-white/[0.05]"
            >
              SKILLS
            </span>

            <div className="relative">
              <span className="text-sm font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                Beyond the classroom
              </span>

              <h3 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal leading-[1.12] sm:text-[43px]">
                Knowledge becomes valuable when you know how to apply it.
              </h3>
            </div>

            <div className="relative border-t border-white/20 pt-7">
              <div className="flex items-end gap-4">
                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[64px] font-normal leading-none text-[#D5AD57]">
                  {String(skills.length).padStart(2, "0")}
                </strong>

                <span className="pb-1 text-sm font-bold uppercase leading-5 tracking-[0.12em] text-white/70">
                  Essential
                  <br />
                  Capabilities
                </span>
              </div>

              <p className="mt-5 text-sm leading-7 text-white/65">
                A balanced skill set designed to support academic development,
                practical application and professional growth.
              </p>
            </div>
          </div>

          {/* RIGHT SKILLS MATRIX */}

          <div className="grid sm:grid-cols-2">
            {skills.map((skill, index) => (
              <article
                key={skill.title}
                className="
                  group
                  relative
                  min-h-[250px]
                  border-b
                  border-[#071A2F]/10
                  p-7
                  transition-colors
                  duration-300
                  sm:border-r
                  sm:p-8
                  lg:p-9
                  hover:bg-[#FDF7FC]
                "
              >
                {/* top */}

                <div className="flex items-center justify-between">
                  <span className="text-xs font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                    Skill
                  </span>

                  <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[24px] text-[#D5AD57]">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                {/* content */}

                <div className="mt-12">
                  <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[28px] font-normal leading-[1.15] text-[#071A2F]">
                    {skill.title}
                  </h3>

                  <p className="mt-4 max-w-[360px] text-[15px] leading-7 text-[#646A74]">
                    {skill.description}
                  </p>
                </div>

                {/* bottom accent */}

                <span
                  className="
                    absolute
                    bottom-0
                    left-0
                    h-[3px]
                    w-0
                    bg-[#8B1E3F]
                    transition-all
                    duration-500
                    group-hover:w-full
                  "
                />
              </article>
            ))}
          </div>
        </div>

        {/* ================= FOOTER LINE ================= */}

        <div className="mt-8 flex flex-col gap-5 border-t border-[#071A2F]/10 pt-7 md:flex-row md:items-center md:justify-between">
          <p className="max-w-[760px] text-sm leading-7 text-[#686D76]">
            Skills developed may vary according to programme curriculum,
            practical components, electives and academic requirements.
          </p>

          <div className="flex items-center gap-4">
            <span className="h-px w-10 bg-[#D5AD57]" />

            <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
              Learn · Apply · Advance
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}